import { Injectable } from "@angular/core"
import { AnimationLoopService } from "./animationloop.service"
import { ApiService } from "./api.service"
import GenerationProfile from "@common-lib/classes/generationprofiles/generationprofile"
import GPInfluenceLoading from "@common-lib/classes/generationprofiles/influences/gpinfluenceloading"
import { FolderService } from "./folder.service"
import { SocketLoadingStatusInput } from "@common-lib/interfaces/api/sockets"

@Injectable()
export class LoadingStatusService {
    readonly waitTimeInSeconds = 25

    private firstTimeLoading = true

    constructor(
        protected animationLoopService: AnimationLoopService,
        protected apiService: ApiService,
        protected folderService: FolderService
    ) {}

    ngOnDestroy() {
        this.animationLoopService.deleteFunctionFromLoop(
            "loadingStatusRefresher"
        )
    }

    init() {
        this.animationLoopService.addFunctionToLoop(
            "loadingStatusRefresher",
            this.loadingStatusRefresher.bind(this),
            this.waitTimeInSeconds * 1000
        )
    }

    async loadingStatusRefresher() {
        try {
            if (this.firstTimeLoading) {
                this.firstTimeLoading = false
                return
            }

            const eventTypes: SocketLoadingStatusInput = {
                generationProfile: null,
                compositions:
                    this.folderService.getContentType() === "Compositions"
                        ? this.getLoadingContent()
                        : [],
                influences:
                    this.folderService.getContentType() === "Influences"
                        ? this.getLoadingContent()
                        : [],
            }

            if (
                eventTypes.generationProfile !== undefined ||
                eventTypes.compositions.length > 0 ||
                eventTypes.influences.length > 0
            ) {
                console.log("Loading status refresher")

                await this.apiService.authRequest(
                    "/socket/loadingStatus",
                    {
                        eventTypes: eventTypes,
                    },
                    "primary",
                    false
                )
            }
        } catch (e) {
            console.error(e)
        }
    }

    getLoadingContent() {
        let loadingContent = []
        const contentEntries = this.folderService.content.getValue()

        for (let content of contentEntries) {
            if (content?.type === "training") {
                continue
            }

            if (!content.isFinished) {
                loadingContent.push(content._id)
            }
        }

        return loadingContent
    }
}
